import { mergeHistoryState, readHistoryStateKey } from './historyEntryState';

const MOBILE_MAP_HISTORY_STATE_KEY = '__hotpadsMobileMapOpen';
const MOBILE_MAP_OPENED_ENTRY_KEY = '__hotpadsMobileMapOpenedEntry';

export function readMobileMapHistoryOpen(state: unknown): boolean {
  return readHistoryStateKey(state, MOBILE_MAP_HISTORY_STATE_KEY) === true;
}

export function pushMobileMapHistoryEntry(): void {
  window.history.pushState({ [MOBILE_MAP_HISTORY_STATE_KEY]: true, [MOBILE_MAP_OPENED_ENTRY_KEY]: true }, '');
}

// Closing the map on the entry that opened it steps back, so no identical list entry is left for Back to land on.
export function popMobileMapHistoryEntry(): void {
  if (readHistoryStateKey(window.history.state, MOBILE_MAP_OPENED_ENTRY_KEY) === true) {
    window.history.back();
  }
}

export function writeMobileMapHistoryOpen(open: boolean): void {
  if (readMobileMapHistoryOpen(window.history.state) === open) return;
  mergeHistoryState({ [MOBILE_MAP_HISTORY_STATE_KEY]: open });
}
